import API from "serviceshift-ui/api-client";

export default {
  fetchJobStatuses({ commit }) {
    return API.makeRequest("/job_statuses.json", {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "jobStatuses",
        data: res.data
      });
    });
  }
};
